import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLang } from "../lib/i18n";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { faqLd, breadcrumbLd } from "../lib/seo";

const faqs = [
  { ru: ["Как забронировать экскурсию?", "Оставьте запрос через форму или напишите нам в Telegram/WhatsApp. Мы уточним даты, детали и подготовим предложение."], en: ["How do I book an excursion?", "Send a request via the form or message us on Telegram/WhatsApp. We'll confirm dates, details and prepare an offer."] },
  { ru: ["Что делать при плохой погоде?", "Порядок и отдельные точки маршрута могут меняться в зависимости от погоды, состояния дорог и требований безопасности."], en: ["What about bad weather?", "The order and individual route points may change depending on weather, road conditions and safety requirements."] },
  { ru: ["Можно ли с детьми?", "Многие маршруты семейные. Для каждого указана рекомендация по детям — уточним при бронировании."], en: ["Can I bring children?", "Many routes are family-friendly. Each has a children note — we'll confirm on booking."] },
  { ru: ["Нужны ли разрешения (ООПТ, погранзона)?", "Для отдельных маршрутов может требоваться оформление доступа в ООПТ или пропуск в погранзону. Условия проверяются перед поездкой."], en: ["Are permits needed (protected areas, border zone)?", "Some routes may require protected-area access or a border-zone permit. Conditions are checked before the trip."] },
  { ru: ["Что взять с собой?", "Рекомендации по одежде и снаряжению зависят от маршрута и сезона — пришлём перед выездом."], en: ["What should I bring?", "Clothing and gear recommendations depend on the route and season — we'll send them before departure."] },
  { ru: ["Как оплатить?", "Условия оплаты обсуждаются индивидуально при подтверждении запроса."], en: ["How do I pay?", "Payment terms are discussed individually when the request is confirmed."] },
];

export default function FaqPage() {
  const { lang } = useLang();
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-page" style={{ background: "#F4F0E7", minHeight: "100vh" }}>
      <Seo
        path="/faq"
        lang={lang}
        title={lang === "ru" ? "Частые вопросы" : "FAQ"}
        description={lang === "ru" ? "Ответы на частые вопросы о бронировании, погоде, детях, разрешениях и подготовке к экскурсиям АРГАЛИ." : "Answers about booking, weather, children, permits and preparing for АРГАЛИ excursions."}
        jsonLd={[faqLd(faqs, lang), breadcrumbLd([{ name: "АРГАЛИ", path: "/" }, { name: "FAQ", path: "/faq" }])]}
      />
      <div className="max-w-3xl mx-auto px-5 md:px-10 pt-32 pb-24">
        <Reveal>
          <p className="eyebrow" style={{ color: "#A96818" }}>FAQ</p>
          <h1 className="display display-md text-argali-obsidian mt-3">{lang === "ru" ? "Частые вопросы" : "Frequent questions"}</h1>
        </Reveal>
        <div className="mt-12">
          {faqs.map((f, i) => (
            <div key={i} className="border-t border-argali-brown/20" data-testid={`faq-${i}`}>
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between py-6 text-left">
                <span className="font-serif text-2xl text-argali-obsidian pr-4">{(lang === "ru" ? f.ru : f.en)[0]}</span>
                <ChevronDown size={22} className={`text-argali-bronze shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <p className="text-argali-brown/80 pb-6 leading-relaxed">{(lang === "ru" ? f.ru : f.en)[1]}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
